
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { withAxios } from 'op/components/auth';
import { withOnlineStatus } from 'op/components/offline';

export const TAGS_PAGE_SIZE = 10;

export const withStpTests = compose(
	withAxios,
	connect(({ stp }, { match }) => ({
		item: stp.loaded.find(item => item.item_ID.toString() == match.params.item_id),
	})),
	withProps(({ item }) => ({ ready: !!item })),
	withState('search', 'setSearch', ''),
	withState('loading', 'setLoading', false),
	withState('tests', 'setTests', []),
	withOnlineStatus,
	withHandlers({
		fetchStpTests: ({ item, setLoading, tests, setTests, axios }) => async ({ page = 0 }) => {
			setLoading(true);

			const skip = page * 10;
			const top = 10;

			const params = new URLSearchParams({
				skip,
				top,
			});

			const { data } = await axios.get(`/api/Stp/getStp10Tests?${params.toString()}`, {
				params: {
					ASM_Item_ID: item.item_ID,
				}
			});

			const joined = data.reduce((acc, curr) => {
				const { stpTestDate, stpTestTime, stpTestCheckedBy, stpTestResult12, stpTestView,
					stpTestResult3, stpTestResult4, stpTestResult5, stpTestResult6, stpMainID, stpMainComments, stpMainPosition } = curr;

				const alreadyExists = acc.find(item => item.stpMainID === stpMainID);

				if (alreadyExists) {
					alreadyExists.results.push({
						stpTestResult12,
						stpTestResult3,
						stpTestResult4,
						stpTestResult5,
						stpTestResult6,
						stpTestView,
					});
				} else {
					acc.push({
						stpTestDate,
						stpTestTime,
						stpTestCheckedBy,
						stpMainID,
						stpMainComments,
						stpMainPosition,
						results: [{
							stpTestView,
							stpTestResult12,
							stpTestResult3,
							stpTestResult4,
							stpTestResult5,
							stpTestResult6,
						}],
					});
				}

				return acc;
			}, []);

			setTests([...tests, ...joined]);
			setLoading(false);
		}
	}),
	lifecycle({
		async componentDidMount() {
			const { online, fetchStpTests } = this.props;

			if (online) {
				await fetchStpTests();
			}
		}
	}),
);
